// eslint-disable-next-line
import home from '@/assets/icons/icon_sy.png'
import course from '@/assets/icons/icon_kc.png'
import lesson from '@/assets/icons/icon_kj.png'
// import resource from '@/assets/icons/icon_zy.png'
import { UserLayout, BasicLayout, BlankLayout } from '@/layouts'
import { bxAnaalyse, school, resource } from '@/core/icons'

const RouteView = {
  name: 'RouteView',
  render: h => h('router-view')
}
export const demo = []

export const supers = []
export const ordinary = []

const asyncRouter = [
  {
    path: '/',
    name: 'home',
    component: BlankLayout,
    redirect: '/ai/chat',
    meta: { title: '详情页', icon: 'profile', permission: ['teacher'] },
    children: [
      {
        path: 'AI',
        name: 'AI',
        component: RouteView,
        redirect: 'AI/repository',
        meta: { title: '知识库', keepAlive: false, icon: course, permission: ['teacher'] },
        children: [
          {
            path: 'chat',
            name: 'aiChat',
            component: () => import('@/views/AI/chat/index'),
            meta: { title: '智能问答', keepAlive: true, permission: ['teacher'] }
          },
          {
            path: 'chat/history',
            name: 'aiChatHistory',
            hidden: true,
            component: () => import('@/views/AI/chat/history'),
            meta: { title: '智能问答历史记录', keepAlive: false, permission: ['teacher'] }
          },
          {
            path: 'chat/teaching-plan',
            name: 'aiChatTeachingPlan',
            hidden: true,
            component: () => import('@/views/AI/chat/teachingPlan/index'),
            meta: { title: '智能生成教案', keepAlive: false, permission: ['teacher'] }
          },
          {
            path: 'app',
            name: 'aiApp',
            hidden: true,
            component: () => import('@/views/AI/app/index'),
            meta: { title: 'AI应用', keepAlive: false, permission: ['teacher'] }
          },
          {
            path: 'app/detail',
            name: 'aiAppDetail',
            hidden: true,
            component: () => import('@/views/AI/app/detail'),
            meta: { title: 'AI应用详情', keepAlive: true, permission: ['teacher'] }
          },
          {
            path: 'model',
            name: 'aiModel',
            hidden: true,
            component: () => import('@/views/AI/model/index'),
            meta: { title: 'AI 模型', keepAlive: false, permission: ['teacher'] }
          },
          {
            path: 'repository',
            name: 'repository',
            hidden: true,
            component: () => import('@/views/AI/repository/index'),
            meta: { title: '知识库', keepAlive: false, icon: 'usb', permission: ['teacher'] }
          },
          {
            path: 'addRepository',
            name: 'addRepository',
            hidden: true,
            component: () => import('@/views/AI/repository/components/AddAndEdit'),
            meta: { title: '新建知识库', keepAlive: false, icon: 'usb', permission: ['teacher'] }
          },
          {
            path: 'createFlow',
            name: 'createFlow',
            hidden: true,
            component: () => import('@/views/AI/repository/components/CreateFlow'),
            meta: { title: '新建流程', keepAlive: false, icon: 'usb', permission: ['teacher'] }
          },
          {
            path: 'repositoryDetails',
            name: 'repositoryDetails',
            hidden: true,
            component: () => import('@/views/AI/repository/components/Details'),
            meta: { title: '知识库详情', keepAlive: false, icon: 'usb', permission: ['teacher'] }
          },
          {
            path: 'repositoryFileDetails',
            name: 'repositoryFileDetails',
            hidden: true,
            component: () => import('@/views/AI/repository/components/FileList'),
            meta: { title: '知识库文件详情', keepAlive: false, icon: 'usb', permission: ['teacher'] }
          },
        ]
      }
    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

export const asyncRouterMap = asyncRouter
/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = []
